import makeStyles from 'e100-react-components/lib/styles/makeStyles';

interface StyleProps {
  hideBorderBottom: boolean;
}

export const useStyles = makeStyles(({
  spacing,
  palette,
  typography
}) => ({
  container: {
    position: 'relative',
  },
  datePicker: ({ hideBorderBottom }: StyleProps) => ({
    '& > div': {
      '&:after': {
        display: 'none'
      },
      '&:before': {
        display: 'none'
      }
    },
    '& input': {
      padding: `${spacing(2.25)}px ${spacing(7.25)}px`,
      fontSize: typography.button.fontSize,
      ...!hideBorderBottom && {
        borderBottom: `1px solid ${palette.grey[200]}`,
      }
    }
  }),
  errorMessage: {
    paddingLeft: spacing(2.5),
    paddingRight: spacing(2.5)
  }
}));
